export default function ReviewStep({ form, projectId, status, liveUrl }) {
    const items = [
        ["Business Name", form.businessName],
        ["Industry", form.industry],
        ["Sub Industry", form.subIndustry],
        ["Tone", form.tone],
        ["Theme", form.themeKey],
        ["Goal", form.goalOfWebsite],
        ["CTA", form.callToActionType],
        ["Brand Style", form.brandStyle],
        ["Price Positioning", form.pricePositioning],
        ["Project ID", projectId || "-"],
        ["Status", status || "Not saved yet"],
        ["Live URL", liveUrl || "-"]
    ];

    return (
        <div>
            <h2 className="wg-section-title">Review & Actions</h2>
            <p className="wg-section-subtitle">
                Review the selected details before saving and publishing.
            </p>

            <div className="wg-review-grid">
                {items.map(([label, value]) => (
                    <div className="wg-review-item" key={label}>
                        <strong>{label}</strong>
                        <span>{value || "-"}</span>
                    </div>
                ))}
            </div>

            <div className="wg-review-item" style={{ marginTop: 16 }}>
                <strong>Description</strong>
                <span>{form.description || "-"}</span>
            </div>
        </div>
    );
}